var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecordVideo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.755,
    height: 12.82,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.318 1.123a.9.9 0 00-.886-.014L14.87 3.054v-.567A2.491 2.491 0 0012.381 0H2.487A2.492 2.492 0 000 2.487v7.846a2.492 2.492 0 002.487 2.487h9.893a2.492 2.492 0 002.486-2.487v-.542l3.566 1.949a.9.9 0 001.218-.371.916.916 0 00.1-.419V1.896a.893.893 0 00-.047-.279zm-1.355 2.283v6.032l-3.1-1.692V5.097zM1.8 2.488a.7.7 0 01.687-.693h9.892a.7.7 0 01.692.692v7.846a.692.692 0 01-.691.692H2.49a.7.7 0 01-.689-.692z",
    fill: "#5200f1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordVideo);
export default __webpack_public_path__ + "static/media/RecordVideo.b82c08fb77870ed889cff1618c7f6f93.svg";
export { ForwardRef as ReactComponent };